export default __webpack_public_path__ + "static/media/element_5.0e57cc97.avif";